var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool_wrap flex-colc"},[_c('div',{staticClass:"tool_item flex-rowc",on:{"click":_vm.goTop}},[_c('span',{staticClass:"iconfont icon-xiangshangjiantou"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }